import { DateTime } from 'luxon';
import { toDateTime, userNow } from 'utils/date';

export type DueDatePreset = 'ALL' | 'FOR_TODAY' | 'FOR_THISWEEK' | 'OVERDUE' | 'NONE';

export interface DateRangeFilter {
  $gt?: string;
  $gte?: string;
  $lt?: string;
  $lte?: string;
}

const startOfLocalDayUtc = (dateTime: DateTime) => (
  dateTime
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .toUTC()
    .toISO()!
);

export const dueDateRangeForPreset = (
  preset: DueDatePreset,
  now: DateTime = userNow(),
): DateRangeFilter | null | undefined => {
  if (preset === 'ALL') {
    return undefined;
  }
  if (preset === 'NONE') {
    return null;
  }
  if (preset === 'FOR_TODAY') {
    return {
      $gte: startOfLocalDayUtc(now),
      $lt: startOfLocalDayUtc(now.plus({ days: 1 })),
    };
  }
  if (preset === 'FOR_THISWEEK') {
    return {
      $gte: startOfLocalDayUtc(now.startOf('week')),
      $lt: startOfLocalDayUtc(now.startOf('week').plus({ days: 7 })),
    };
  }
  return {
    $lt: startOfLocalDayUtc(now),
  };
};

export const matchesDueDatePreset = (
  value: Date | string | null | undefined,
  preset: DueDatePreset,
  now: DateTime = userNow(),
) => {
  if (preset === 'ALL') {
    return true;
  }
  const dueAt = toDateTime(value);
  if (preset === 'NONE') {
    return !dueAt;
  }
  if (!dueAt) {
    return false;
  }
  const range = dueDateRangeForPreset(preset, now);
  if (!range) {
    return true;
  }
  if (range.$gt && dueAt <= DateTime.fromISO(range.$gt)) return false;
  if (range.$gte && dueAt < DateTime.fromISO(range.$gte)) return false;
  if (range.$lt && dueAt >= DateTime.fromISO(range.$lt)) return false;
  if (range.$lte && dueAt > DateTime.fromISO(range.$lte)) return false;
  return true;
};
